module.exports = __webpack_public_path__ + "img/bill-icon.89dd5b0d.png";